import { useTranslation } from 'react-i18next';
import { languageStorage } from '../utils/languageStorage';

/**
 * Language switcher component with flag images and segmented control styling
 */
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    languageStorage.set(lang);
  };

  return (
    <div className="segmented-control" role="group" aria-label="Language selection">
      <button
        onClick={() => handleLanguageChange('cs')}
        className={`segmented-control__button ${
          i18n.language === 'cs'
            ? 'segmented-control__button--active'
            : 'segmented-control__button--inactive'
        }`}
        aria-label="Switch to Czech"
        aria-pressed={i18n.language === 'cs'}
      >
        <img 
          src="/img/flags/cs.svg" 
          alt="Czech flag" 
          className="w-6 h-4 object-cover rounded-sm"
        />
      </button>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`segmented-control__button ${
          i18n.language === 'en'
            ? 'segmented-control__button--active'
            : 'segmented-control__button--inactive'
        }`}
        aria-label="Switch to English"
        aria-pressed={i18n.language === 'en'}
      >
        <img 
          src="/img/flags/en.svg" 
          alt="UK flag" 
          className="w-6 h-4 object-cover rounded-sm"
        />
      </button>
    </div>
  );
}
